export default { API_URL: process.env.REACT_APP_SERVER_URL };
